module.exports = __webpack_public_path__ + "e54ee2d6849bd36262104266eb8a80a9.woff";